export default "__VITE_ASSET__Bk1NVxuP__"